import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AppConfig} from '../app.config';
import 'rxjs/add/operator/map';
// import 'rxjs/Rx';

@Injectable()
export class ContentService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = AppConfig.API_URL;
  }

  /**@author Lupita Llamas
   * SErvicio principal, trae la info del cliente a mostrar
   * @returns {Observable<any>}
   */
  public dataTest(unique, token): Observable <any> {
    return this.http.get(this.url + 'card/' + unique + '/' + token, {}).map((response: Response) => {
      return response;
    });
  }

  /**@author Lupita Llamas
   * Servicio que regresa las preguntas de un id
   * @param unique
   * @returns {Observable<any>}
   */
  public questionsData(unique): Observable <any> {
    return this.http.get(this.url + 'get-questions/' + unique, {}).map((response: Response) => {
      return response;
    });
  }

  /**@author Lupita Llamas
   * Envia correo
   * @returns {Observable<any>} 200 y message, algo salió mal 404, Conexion con ws 500
   */
  public sendEmail(answer): Observable <any> {
    return this.http.post(this.url + 'send-email', answer).map((response: Response) => {
      return response;
    });
  }

  /**@author Lupita Llamas
   *
   * @param info
   * @returns {Observable<Response>}
   */
  public sendStats(info) {
    return this.http.post(this.url + 'wow-stats', info).map((response: Response) => {
      return response;
    });
  }

  /**@author Lupita Llamas
   * Return the configuration for the image viwer
   * @returns config
   */
  public configImageViewer() {
    return {
      btnClass: '', // The CSS class(es) that will apply to the buttons
      containerBackgroundColor: '', // The color to use for the background. This can provided in hex, or rgb(a).
      wheelZoom: false, // If true, the mouse wheel can be used to zoom in
      allowFullscreen: false, // If true, the fullscreen button will be shown, allowing the user to entr fullscreen mode
      allowKeyboardNavigation: false, // If true, the left / right arrow keys can be used for navigation
      btnIcons: { // The icon classes that will apply to the buttons. By default, font-awesome is used.
        zoomIn: 'fa fa-plus',
        zoomOut: 'fa fa-minus',
        rotateClockwise: 'fa fa-repeat',
        rotateCounterClockwise: 'fa fa-undo',
        next: '',
        prev: '',
        fullscreen: 'fa fa-arrows-alt',
      },
      btnShow: {
        zoomIn: false,
        zoomOut: false,
        rotateClockwise: false,
        rotateCounterClockwise: false,
        next: false,
        prev: false
      }
    };
  }
}





// WEBPACK FOOTER //
// ./src/app/services/content.service.ts